export default "__VITE_ASSET__jsyKxUIz__"